import { useEffect, useMemo } from 'react';
import useCountryStore from '../store/countryStore';
import { getUserRole } from '../utils/storage';

/**
 * 
 * @param {Object} props
 * @param {any[]} props.countryList - List of country options {value, label}.
 * @param {Function} [props.setSelectedCountry] - React state setter for the current selection.
 * @param {Function} [props.setFieldValue] - Formik (or other) field updater.
 * @param {string} [props.fieldName] - The form field name to be synced.
 */
export const useAutoSelectCountry = ({
  countryList,
  setSelectedCountry,
  setFieldValue,
  fieldName,
}) => {
  const { selectedCountryId } = useCountryStore();
  const matchedCountry = useMemo(() => {
    if (!countryList?.length || !selectedCountryId) return null;

    return countryList.find(
      (c) =>
        String(c.value || c.countryId) === String(selectedCountryId)
    );
  }, [countryList, selectedCountryId]);

  useEffect(() => {
    const role = getUserRole();
    if (role !== 5 && role !== '5') return;
    if (!matchedCountry) return;

    const value = matchedCountry.value || matchedCountry.countryId;
    const label = matchedCountry.label || matchedCountry.countryName;

    setSelectedCountry?.({ value, label });

    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, value);
    }
  }, [matchedCountry, selectedCountryId, setSelectedCountry, setFieldValue, fieldName]);
};

export default useAutoSelectCountry;